import { FieldTeamVisibility } from "@mapmycustomers/shared/enum/FieldVisibility";
import Role from "@mapmycustomers/shared/types/Role";
import FieldTeamVisibilityRecord from "@mapmycustomers/shared/types/schema/FieldTeamVisibilityRecord";
import Team from "@mapmycustomers/shared/types/Team";

export const doTeamsHaveUniformRoles = (
  teamVisibility: FieldTeamVisibilityRecord[],
  roles: Role[]
): boolean =>
  roles.every((role) =>
    teamVisibility
      // take all visibilities which are related to current role...
      .filter((visibility) => visibility.role.id === role.id)
      // ...and ensure that every filtered record uses same visibility [as the first filtered record]
      .every((record, index, records) => record.visibility === records[0].visibility)
  );

export const buildFieldVisibilityRecordForTeamRole = (
  team: null | Team,
  roleId: Role["id"],
  visibility: FieldTeamVisibility
): FieldTeamVisibilityRecord =>
  ({ role: { id: roleId }, team, visibility } as FieldTeamVisibilityRecord);

export const createTeamVisibilityFromRoleVisibility = (
  roleVisibility: Record<Role["id"], FieldTeamVisibility>,
  roles: Role[],
  teams: Team[]
) => {
  return roles.reduce(
    (result, role) => [
      ...result,
      ...[null, ...teams].map((team) =>
        buildFieldVisibilityRecordForTeamRole(team, role.id, roleVisibility[role.id])
      ),
    ],
    [] as FieldTeamVisibilityRecord[]
  );
};
